import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import ui from '@/store/modules/ui';
import booking from '@/store/modules/booking';
import shop from '@/store/modules/shop';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
// console.log('debug', debug);

export default new Vuex.Store({
  modules: {
    auth,
    ui,
    booking,
    shop
  },
  strict: debug,
});